<template>
  <div class="Width100P">
    <frame-header
    v-on:iframe-closed="iframeClosed"
    v-on:iframe-minimized="iframeMinimized"
    ></frame-header>

    <div class="intermediate-view">
      <div v-for="node in nodesArray" :key="node"> 
      <h2>{{node}}</h2>
      <ul v-for="app in nodesMessages(node)" :key="app.uniqueId">
        <li @click="ItemSelected(app)">
          <img class="img" v-bind:src="AppScreenShoot(app.name)" />
          <label>{{`${app.name} - ${app.messageName}`}}</label>
          <label class="name">{{app.type}}</label>
        </li>
      </ul>
      </div>
    </div>
  </div>
</template>

<script>
import FrameHeader from "./../viewMode/FrameHeader.vue";

export default {
  name: "IntermediateViewComponent",
  props: ["nodes"],
  components: {
    FrameHeader,
  },
  methods: {
    ItemSelected(node) {
      this.$emit("intermediate-view-item-selected", node);
    },
     nodesMessages:function(appname){
      return this.nodes[appname];
    },
    AppScreenShoot:function(appname){
      var img=appname.replace(' ','').toLocaleLowerCase();
      
      return require(`../../assets/images/AppsScreenShot/${img}.png`);
    },
    iframeClosed:function(){
      this.$emit('iframe-closed');
    },
    iframeMinimized:function(){
      this.$emit('iframe-minimized');
    }
  },
  computed:{
    
    nodesArray:function(){
      var keys= Object.keys(this.nodes);
      return keys;
    }
  },
  mounted() {}
};
</script>

<style>
.img{
  width: 314px;
  height: 143px;
}
.intermediate-view {
  background: #4980b3;
  overflow: auto;
  width: calc(100vw - 85px);
  height: calc(100vh - 4.9rem); /* fallback if css var is not supported*/
  height: calc(calc(var(--vh, 1vh) * 100) - 4.9rem);
  display: block;
  position: absolute;
  left: 80px;
  padding: 2rem;
}
.intermediate-view h2 {
  margin: 0 10px 10px;
  font-size: 22px;
}
.intermediate-view ul {
  display: inline-block;
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s ease;
}
.intermediate-view ul:first-child {
  padding: 0;
}
.intermediate-view ul li {
  list-style: none;
}
.intermediate-view ul li img {
  display: block;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.16);
}
.intermediate-view ul li label {
  margin-top: 7px;
}
.intermediate-view ul li label.name {
  border: solid 1px #fff;
  display: block;
  width: fit-content;
  padding: 1px 5px;
  font-size: 13px;
  margin: 0;
}
.intermediate-view ul:hover {
  background: #fff;
  color: #40454d;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
}
.intermediate-view ul:hover li label.name {
  border: solid 1px #40454d;
}
</style>